export default "__VITE_ASSET__CpHeW9Mk__"